export default __webpack_public_path__ + "static/media/LGBTQ2_en.fd70d610.svg";